import React, { useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router"
import {
  setIsManagerMode,
  setShowDriversOnRoute,
} from "../../../pages/mainPage/mainPageSlice.js"
import { ButtonWhite } from "../../common/buttonWhite/buttonWhite"
import "./managerHeader.scss"

export function ManagerHeader() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isManagerMode, showDriversOnRoute } = useSelector(
    (state) => state.main
  )
  const { userData } = useSelector((state) => state.loginOTP)

  return (
    <header className="managerHeader">
      <div className="managerHeader-container">
        {userData?.role === "Manager" && (
          <ButtonWhite
            text={isManagerMode ? "🚚 מצב נהג" : "💼 מצב מנהל"}
            clickHandler={() => dispatch(setIsManagerMode(!isManagerMode))}
          />
        )}
        {isManagerMode && (
          <ButtonWhite
            text="נהגים"
            clickHandler={() =>
              dispatch(setShowDriversOnRoute(!showDriversOnRoute))
            }
          />
        )}
      </div>
    </header>
  )
}
